module.exports = __webpack_public_path__ + "static/media/1046784.96c00f56.svg";